import React from 'react';

export function lenderInitials(name) {
  if (!name) return '?';
  const parts = String(name).replace(/[-–—]/g, ' ').split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + (parts[1][0] || '')).toUpperCase();
}

// Deterministic color palette for lender avatars (no purple/violet)
const PALETTE = [
  { bg: 'bg-emerald-500/10', text: 'text-emerald-600', border: 'border-emerald-500/20' },
  { bg: 'bg-amber-500/10', text: 'text-amber-600', border: 'border-amber-500/20' },
  { bg: 'bg-sky-500/10', text: 'text-sky-600', border: 'border-sky-500/20' },
  { bg: 'bg-rose-500/10', text: 'text-rose-600', border: 'border-rose-500/20' },
  { bg: 'bg-teal-500/10', text: 'text-teal-600', border: 'border-teal-500/20' },
  { bg: 'bg-lime-500/10', text: 'text-lime-600', border: 'border-lime-500/20' },
  { bg: 'bg-orange-500/10', text: 'text-orange-600', border: 'border-orange-500/20' },
  { bg: 'bg-cyan-500/10', text: 'text-cyan-600', border: 'border-cyan-500/20' },
];

export function lenderColor(name) {
  if (!name) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export default function LenderBadge({ name, size = 'md' }) {
  const color = lenderColor(name);
  const sizes = {
    sm: 'h-6 w-6 text-[10px]',
    md: 'h-8 w-8 text-xs',
    lg: 'h-12 w-12 text-sm',
    xl: 'h-16 w-16 text-base',
  };
  return (
    <span
      className={`inline-flex items-center justify-center rounded font-heading font-semibold tracking-tight border ${color.bg} ${color.text} ${color.border} ${sizes[size]}`}
      data-testid={`lender-badge-${name?.replace(/\s/g, '-')}`}
    >
      {lenderInitials(name)}
    </span>
  );
}
